module.exports = __webpack_public_path__ + "img/home_vedio_img02.c2aea866.jpg";